import { CommonModule } from '@angular/common'
import { Component } from '@angular/core'
import { MatIconModule } from '@angular/material/icon'
import { LandingPageSectionContainerModule } from '@landing-page/components/container/landing-page-section-container.module'
import { TranslationModule } from '@localization-lib/language/translation.module'
import { AccordionComponent } from '@shared-ui-lib/accordion/accordion.component'
import { CollapsibleComponent } from '@shared-ui-lib/collapsible/collapsible.component'
import { ExpandableModule } from '@shared-ui-lib/expandable/expandable.module'
import { WagonHireHistoryRequestHeaderModule } from '@wagon-hire/wagon-hire-history/wagon-hire-history-request-header/wagon-hire-history-request-header.module'

@Component({
    standalone: true,
    imports: [
        CommonModule,
        ExpandableModule,
        MatIconModule,
        WagonHireHistoryRequestHeaderModule,
        LandingPageSectionContainerModule,
        TranslationModule,
        AccordionComponent,
        CollapsibleComponent,
    ],
    selector: 'app-landing-page-faq',
    templateUrl: './landing-page-faq.component.html',
    styleUrls: ['./landing-page-faq.component.scss'],
})
export class LandingPageFAQComponent {
    faqs: string[] = [
        'faq-can-i-use-traigo-for-free',
        'faq-is-traigo-part-of-vtg',
        'faq-i-am-not-a-customer-of-vtg-rail-europe',
        'faq-can-i-use-traigo-for-non-vtg-wagons',
        'faq-how-can-i-learn-more',
        'faq-what-features-has-traigo',
        'faq-processing-traigo-data',
        'faq-i-dont-see-all-my-contracts',
        'faq-how-does-wagon-tracking-work',
        'faq-where-are-wagon-details',
    ]

    constructor() {}
}
